<template>
  <div id="contenedor-localidades">
    <v-container fluid>
      <v-card class="mb-4 rounded-lg" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Localidades">
            <template v-slot:opciones-derecha>
              <v-btn
                color="primary"
                class="white--text"
                rounded
                @click="dialog = true"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </template>
          </titulo-tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat class="rounded-lg">
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="listadoLocalidades"
            :items-per-page="10"
          >
            <template v-slot:item.acciones="{ item }">
              <v-btn icon @click="mixPrepararEdicionCatalogoLocalidad(item)">
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon @click="deleteItem(item)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              No hay localidades registradas.
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" max-width="600px" scrollable persistent>
      <agregar-localidad @cerrar="dialog = false" />
    </v-dialog>
    <v-dialog v-model="showDialogEliminar" max-width="500px" persistent>
      <v-card>
        <v-card-title class="secondary--text">
          Confirmar eliminación
          <v-spacer></v-spacer>
          <v-btn icon @click="showDialogEliminar = false">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          ¿Está seguro que desea eliminar la localidad
          <strong>{{ catalogoLocalidadEliminar.descripcion }}</strong>?
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="showDialogEliminar = false"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="confirmarEliminacion"
            tipo="formAceptar"
            label="Eliminar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AgregarLocalidad from '@/components/administracion/configuracion/catalogos/localidades/Agregar.vue';
import mixCatalogoLocalidades from '@/components/administracion/configuracion/catalogos/localidades/mixCatalogoLocalidades';

export default {
  name: 'CatalogoLocalidadesView',
  mixins: [mixCatalogoLocalidades],
  components: {
    CustomButton,
    TituloToolBar,
    AgregarLocalidad,
  },
  data() {
    return {
      dialog: false,
      showDialogEliminar: false,
      headers: [
        { text: 'Municipio', value: 'municipio.nombre' },
        { text: 'Descripción', value: 'descripcion' },
        {
          text: 'Acciones', value: 'acciones', sortable: false, width: '200px',
        },
      ],
      catalogoLocalidadEliminar: { id: null, descripcion: '' },
    };
  },
  methods: {
    async deleteItem(item) {
      this.catalogoLocalidadEliminar = item;
      this.showDialogEliminar = true;
    },
    async confirmarEliminacion() {
      await this.mixRemoverCatalogoLocalidad(this.catalogoLocalidadEliminar.id);
      this.showDialogEliminar = false;
    },
  },
  computed: {
    listadoLocalidades() {
      if (!this.catalogoLocalidades) {
        return [];
      }

      return this.catalogoLocalidades;
    },
  },
};
</script>

<style lang="scss">

</style>
